import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button } from '@material-ui/core'
import '../App.css';
import Loan from 'loan';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: '#40bfa3',
        borderRadius: '3.25rem',
        border: 0,
        color: '#00005e',
        fontSize: '1.125rem',
        fontFamily: 'NordeaSansSmall',
        fontWeight: '700',
        padding: '10px 38px'
    },
    wrapper: {
        width: '100%',
        padding: '15px 0'
    },
    label: {
        color: 'rgb(0,0,160)',
        fontSize: '25px',
        fontWeight: '900',
        textAlign: 'center'
    },
    sliderBox: {
        margin: '0 100px'
    },
    sliderBoxInner: {
        display: 'flex'

    },
    sliderBoxRight: {
        marginLeft: 'auto',
        order: 2
    }
}));



const CalculationSummary = props => {

    const classes = useStyles();
    const years = props.pageType === 4 ? props.years : Number(props.years) * 12;

    let loan = new Loan({
        type: props.config.misc.mortgageType,
        pay_every: 'month',
        principal: Number(props.amount),
        interest_rate: Number(props.intrest === 0 ? 0.0 : props.intrest / 100),
        invoice_fee: Number(props.config.misc.invoiceFee),
        initial_fee: Number(props.config.misc.initialFee),
        instalments: Number(years)
    });

    let averageMonthlyPay = 0;

    loan.getPaymentPlan().forEach(item => {
        averageMonthlyPay += item.to_pay
    })
    averageMonthlyPay = Number((Number(averageMonthlyPay) / Number(years)).toFixed(0));

    const redirectTo = () => {
        window.open(props.config.applay.link, "_blank")
        //window.location.href = `https://nordea.siriusit.net/formser-vice/formDownload?serviceName=e-credit_nordea&scriptcomponent.cmtagname=trex-nordea-e_blanco-cf-d&service_name=e_blanco&Produc-tID=444&StoreID=E444001`
    }

    let amountToPayPerMonth = 0;
    if (props.pageType === 5) {
        amountToPayPerMonth = Number(loan.getPaymentPlan()[0].to_pay.toFixed(0));
    } else {
        amountToPayPerMonth = Number(loan.getPaymentPlan()[3].to_pay.toFixed(0)) + Number(props.config.misc.invoiceFee);
    }

    const renderSummary = type => {
        if (type === 4) {
            return (<div className={classes.wrapper}>
                <div className={classes.sliderBox}>

                    <div className={classes.sliderBoxInner}>
                        <div style={{ width: '100%' }}>
                            <div className="nordea-large" style={{ display: 'flex', alignItems: 'center', color: props.config.misc.color }} >
                                <h2 style={{ display: 'inline-block', fontSize: '22px', color: props.config.misc.color, fontWeight: 400 }}>Ränta</h2>
                                <span style={{ display: 'inline-block', fontWeight: 400, fontSize: '22px', marginLeft: 'auto' }}>{props.intrest === 0 ? '0%' : props.intrest + '%'}</span>
                            </div>
                        </div>
                    </div>
                    <div className={classes.sliderBoxInner}>
                        <div style={{ width: '100%' }}>
                            <div className="nordea-large" style={{ display: 'flex', alignItems: 'center', color: props.config.misc.color }}>
                                <h2 style={{ display: 'inline-block', fontSize: '22px', color: props.config.misc.color, fontWeight: 400 }}>{props.config.label.initialFee}</h2>
                                <span style={{ display: 'inline-block', fontWeight: 400, fontSize: '22px', marginLeft: 'auto' }}>{props.config.misc.initialFee} kr</span>
                            </div>
                        </div>
                    </div>
                    <div className={classes.sliderBoxInner}>
                        <div style={{ width: '100%' }}>
                            <div className="nordea-large" style={{ display: 'flex', alignItems: 'center', color: props.config.misc.color }}>

                                <h2 style={{ display: 'inline-block', fontSize: '22px', color: props.config.misc.color, fontWeight: 400 }}>{props.config.label.invoiceFee}</h2>
                                <span style={{ display: 'inline-block', fontWeight: 400, fontSize: '22px', marginLeft: 'auto' }}>{props.config.misc.invoiceFee} kr</span>
                            </div>
                        </div>
                    </div>
                    <div className={classes.sliderBoxInner}>
                        <div style={{ width: '100%' }}>
                            <div className="nordea-large" style={{ display: 'flex', alignItems: 'center', color: props.config.misc.color }}>
                                <h2 style={{ display: 'inline-block', fontSize: '22px', color: props.config.misc.color, fontWeight: 400 }}>{props.buyNow ? 'Betalning' : props.config.label.toPay}</h2>
                                <span style={{ display: 'inline-block', fontSize: '22px', marginLeft: 'auto' }}> {props.buyNow ? (Number(props.amount) + Number(props.config.misc.invoiceFee) + Number(props.config.misc.initialFee)).toLocaleString("sv-SE", props.sekFormat).replace(',00', '') : amountToPayPerMonth.toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</span></div>
                        </div>
                    </div>
                    <div style={{ textAlign: 'center', margin: '20px 0 30px 0' }}>
                        <Button style={{ backgroundColor: props.config.misc.applyButton }} className={classes.root} variant="contained" onClick={e => { redirectTo() }}>{props.config.applay.title}</Button>
                    </div>
                </div>
            </div >);
        }
        return (<div className={classes.wrapper}>
            <div className={classes.sliderBox}>
                <h2 style={{ textAlign: 'center', fontSize: '18px', color: `${props.config.misc.color}`, fontWeight: 400 }}>{props.pageType === 5 ? 'Första månadsbetalning' : 'Månadsbetalning'}</h2>
                <div className={classes.sliderBoxInner}>
                    <div style={{ margin: '0 auto' }}>
                        <div className="nordea-large" style={{ color: props.config.misc.color }}> {amountToPayPerMonth.toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}
                        </div>
                        <Box>{props.pageType === 5 ? 'Rak amortering' : 'Annuitetsbelopp'}</Box>
                    </div>

                </div>
                <div style={{ textAlign: 'center', margin: '20px 0 30px 0' }}>
                    {!!props.config.misc.visibility.applyButton && <Button className={classes.root} variant="contained" onClick={e => { redirectTo() }}>{props.config.applay.title}</Button>}
                </div>
            </div>
            {props.pageId === 61 && (
                <div className={classes.sliderBox} style={{ paddingBottom: 20 }}>
                    <h2 style={{ textAlign: 'center', fontSize: '18px', color: `${props.config.misc.color}`, fontWeight: 400 }}>Genomsnittlig månadsbetalning</h2>
                    <div className={classes.sliderBoxInner}>
                        <div style={{ margin: '0 auto' }}>
                            <div className="nordea-large" style={{ color: props.config.misc.color }}> {averageMonthlyPay.toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}
                            </div>
                        </div>
                    </div>
                </div>)}
        </div>);
    }

    return (renderSummary(props.pageType));
}

export default CalculationSummary; 